// extracted by mini-css-extract-plugin
export default {"wrap":"Card_wrap__6cjpf","no-padding":"Card_no-padding__2urgu"};